interface SanitizableObject {
  [key: string]: any;
}

interface IRequest {
  reqId: string;
  url: string;
  headers: Record<string, string>;
  method: string;
  [key: string]: any;
}

const sanitizeNetworkData = (sensitiveFields: string[]) => (data: IRequest): IRequest => {
  // Fields that need to be sanitized
  const sanitizeObject = (obj: SanitizableObject): SanitizableObject => {
    const sanitizedObj = { ...obj };

    for (const key in sanitizedObj) {
      sensitiveFields.forEach((field) => {
        if (sanitizedObj[field]) {
          sanitizedObj[key] = '***';
        }
      });
    }

    return sanitizedObj;
  };

  if (data.body) {
    try {
      const body: SanitizableObject = JSON.parse(data.body);

      // Loop through each object in the data
      for (const key in body) {
        sensitiveFields.forEach((field) => {
          if (body[key][field]) {
            body[key] = sanitizeObject(body[key]);
          }
        });
      }

      data.body = JSON.stringify(body);
    } catch {}
  }

  return data;
};

export default sanitizeNetworkData;